import { useDispatch } from "react-redux";
import { resumeJourney } from "../features/journey";
import * as LocalStoragePersister from "../common/LocalStoragePersister";
import { resumeLibrary } from "../features/acoustics/AudioLibraryReducer";
import { resumeListenerProfile } from "../features/listenerProfile";
import VerticalCenter from "../common/components/VerticalCenter";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Padding from "../common/components/Padding";
import Center from "../common/components/Center";
import { resumeApplication } from "../features/application/ApplicationReducer";
import AudioFlower from "../common/components/AudioFlower";

const COUNTDOWN_TO_CONTINUE_SEC = 5;

const TakeABreath = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_TO_CONTINUE_SEC);

  const onContinue = () => {
    dispatch(resumeJourney(LocalStoragePersister.previousJourney()));
    dispatch(resumeLibrary(LocalStoragePersister.previousAudioLibrary()));
    dispatch(
      resumeListenerProfile(LocalStoragePersister.previousListenerProfile())
    );
  };

  useEffect(() => {
    dispatch(resumeApplication(LocalStoragePersister.previousApplication()));
  }, []);

  useEffect(() => {
    LocalStoragePersister.removeStallFalg();
    setSecondsLeft(COUNTDOWN_TO_CONTINUE_SEC);
  }, []);

  useEffect(() => {
    const timerId = setInterval(() => {
      setSecondsLeft((oldSeconds) => oldSeconds - 1);
    }, 1000);

    return () => {
      setSecondsLeft(COUNTDOWN_TO_CONTINUE_SEC);
      clearInterval(timerId);
    };
  }, []);

  // Move to next step when countdown expires
  useEffect(() => {
    if (secondsLeft <= -1) {
      onContinue();
    }
  }, [secondsLeft]);

  return (
    <VerticalCenter>
      <Padding>
        <Padding>
          <Center>
            <AudioFlower animate />
          </Center>
        </Padding>
      </Padding>
      <Padding>
        <Center>
          <h2>{t("Let's take a breath before we continue.")}</h2>
          <h2 className="breath-countdown">{secondsLeft}</h2>
        </Center>
      </Padding>
    </VerticalCenter>
  );
};

export default TakeABreath;
